import { useLang } from '@/i18n';
import EcoSection from 'eco-design/base/eco-section';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoTabSwiper from 'eco-design/sections/eco-tab-swiper';
import { useRouter } from 'next/router';
import CardInfoBtn from './CardInfoBtn';
import styles from './index.module.scss';

const tabConfig = [
    {
        id: 'A1',
        img: {
            na: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1745744254399/Kitchen.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1745744253535/Kitchen%20(1).jpg',
            },
            other: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764761381367-ad7fjp-compressed-Kitchen.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764761403393-s52a2c-compressed-Kitchen.jpg',
            },
        },
        cardPrefix: 'a',
        cardCount: 4,
    },
    {
        id: 'A2',
        img: {
            na: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1745744255400/Living%20Room.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1745744253771/living%20room%20(1).jpg',
            },
            other: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764761355037-2uirhp-compressed-Living%20Room.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764761320817-a2dm5m-compressed-living%20room.jpg',
            },
        },
        cardPrefix: 'b',
        cardCount: 4,
        hasRichText: true,
    },
    {
        id: 'A3',
        img: {
            na: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1745744254081/Laundry%20Room.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1745744254205/Laundry%20Room%20(1).jpg',
            },
            other: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764761274395-kobc3o-compressed-Laundry%20Room.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764761303761-4frmzt-compressed-Laundry%20Room.jpg',
            },
        },
        cardPrefix: 'c',
        cardCount: 3,
    },
    {
        id: 'A4',
        img: {
            na: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1745744254627/Yard.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1745744254825/Yard%20(1).jpg',
            },
            other: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764761245884-r8ni0j-compressed-Garage.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764761226377-b1jet0-compressed-Garage.jpg',
            },
        },
        cardPrefix: 'd',
        cardCount: 4,
    },
    {
        id: 'A5',
        img: {
            na: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1745744255054/Office.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1745744255242/office%20(1).jpg',
            },
            other: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764761168728-lk1ftg-compressed-Office.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764761208100-z0z6zh-compressed-office.jpg',
            },
        },
        cardPrefix: 'e',
        cardCount: 4,
    },
];

export default function Comp() {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('dp3.page_v2.TabSwiperA');
    const IS_NA_SITES = ['us', 'ca'].includes(locale);

    const items = tabConfig.map((tab, index) => {
        const itemIndex = index + 1;
        const { id, img, cardPrefix, cardCount, hasRichText } = tab;
        const images = IS_NA_SITES ? img.na : img.other;

        let moreBtnContent;
        if (hasRichText) {
            moreBtnContent = (
                <>
                    <CardInfoBtn className="b1" text={t('item2_t1')} desc={t('item2_d1')} />
                    <CardInfoBtn className="b2" text={t('item2_t2')} desc={t('item2_d2')} />
                    <CardInfoBtn
                        className="b3"
                        text={t.rich('item2_t3', {
                            i: (v: any) => `${v}`,
                        })}
                        desc={t.rich('item2_d3', {
                            i: (v: any) => `${v}`,
                        })}
                    />
                    <CardInfoBtn className="b4" text={t('item2_t4')} desc={t('item2_d4')} />
                </>
            );
        } else {
            const buttons = Array.from({ length: cardCount }, (_, i) => {
                const cardIndex = i + 1;
                return (
                    <CardInfoBtn
                        key={cardIndex}
                        className={`${cardPrefix}${cardIndex}`}
                        text={t(`item${itemIndex}_t${cardIndex}`)}
                        desc={t(`item${itemIndex}_d${cardIndex}`)}
                    />
                );
            });
            moreBtnContent = <>{buttons}</>;
        }

        return {
            pc: images.pc,
            pad: images.pc,
            h5: images.h5,
            tabLabel: t(`tab${itemIndex}`),
            tabValue: id,
            moreBtnContent,
        };
    });

    return (
        <div className={styles.comp} id="TabSwiperA">
            {IS_NA_SITES && <EcoSpace />}
            <EcoSection title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <EcoTabSwiper items={items} />
        </div>
    );
}
